import { isMultirolePartner } from '@/authProvider'
import { Admin } from './Admin'
import { MultiRolePartner } from './MultiRolePartner'

export const PartnersSelect = () => {
  if (isMultirolePartner()) {
    return <MultiRolePartner />
  }

  return <Admin />
}
